// extracted by mini-css-extract-plugin
module.exports = {"heroWrapper":"page_heroWrapper__uIHnx","pageContent":"page_pageContent__xhKJy","hiddenOverflow":"page_hiddenOverflow__UmQ_w"};